import { render } from "./VInput.vue?vue&type=template&id=605c422d&ts=true"
import script from "./VInput.vue?vue&type=script&lang=ts"
export * from "./VInput.vue?vue&type=script&lang=ts"

import "./VInput.vue?vue&type=style&index=0&id=605c422d&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__